import { render } from "./ClueView.vue?vue&type=template&id=0646c3a6&scoped=true&ts=true"
import script from "./ClueView.vue?vue&type=script&lang=ts"
export * from "./ClueView.vue?vue&type=script&lang=ts"

import "./ClueView.vue?vue&type=style&index=0&id=0646c3a6&scoped=true&lang=scss"

import exportComponent from "C:\\vue项目\\baiduobang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0646c3a6"]])

export default __exports__